import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import ModalDecorator from 'hocs/ModalDecorator';
import BuyTrialCreditModalInner from './BuyTrialCreditModalInner';

class BuyTrialCreditModal extends Component {
  constructor(props) {
    super(props);
    $.noConflict();
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#buy-trial-credit-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#buy-trial-credit-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#buy-trial-credit-modal').modal('hide');
  };

  render() {
    return (
      <Elements>
        <BuyTrialCreditModalInner modalProps={this.props.modalProps} />
      </Elements>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalProps: state.visibleModal.props,
  };
}

export default compose(
  ModalDecorator('buy-trial-credit-modal'),
  connect(mapStateToProps, {})
)(BuyTrialCreditModal);



// WEBPACK FOOTER //
// ./src/components/modals/BuyTrialCreditModal/index.js